








import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";
import {setMeta} from "../../modules/utils";

@Component
export default class NotFound extends CommonBase{

    mounted() {
        // Add not found meta so that rendertron returns correct statuscode
        setMeta("render:status_code", "404");
    }
}
